import { companyInfo } from "@/mocks/home";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";


export default function Company() {
  const { ref: leftRef, isVisible: leftVisible } = useScrollAnimation();
  const { ref: rightRef, isVisible: rightVisible } = useScrollAnimation();
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation();

  return (
    <section id="company" className="relative py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div
            ref={titleRef}
            className={`text-center mb-12 md:mb-16 transition-all duration-700 ${
              titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            <h2 className="flex items-center justify-center gap-4 md:gap-8 text-2xl md:text-4xl lg:text-5xl font-black font-heading text-foreground-50">
              <span className="w-16 md:w-52 h-px bg-gradient-to-l from-primary-500 to-transparent" />
              会社概要
              <span className="w-16 md:w-52 h-px bg-gradient-to-r from-primary-500 to-transparent" />
            </h2>
            <p className="text-primary-400 text-sm">COMPANY PROFILE</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-stretch">
            {/* 左側：会社情報 */}
            <div
              ref={leftRef}
              className={`bg-background-200 border border-background-300/30 rounded-xl p-6 md:p-8 lg:p-10 transition-all duration-700 h-full ${
                leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-6"
              }`}
            >
              <div className="space-y-6">
                <div className="border-b border-background-300/30 pb-6">
                  <h3 className="text-foreground-500 text-sm font-medium mb-2">会社名</h3>
                  <p className="text-foreground-50 text-lg">{companyInfo.name}</p>
                  <p className="text-foreground-600 text-sm">{companyInfo.englishName}</p>
                </div>

                <div className="border-b border-background-300/30 pb-6">
                  <h3 className="text-foreground-500 text-sm font-medium mb-2">所在地</h3>
                  <p className="text-foreground-50 text-base">{companyInfo.address}</p>
                  <p className="text-foreground-600 text-sm mt-1">
                    <i className="ri-train-line mr-1"></i>
                    {companyInfo.station}
                  </p>
                </div>

                <div className="border-b border-background-300/30 pb-6">
                  <h3 className="text-foreground-500 text-sm font-medium mb-2">電話番号</h3>
                  <a
                    href={`tel:${companyInfo.phone}`}
                    className="text-primary-400 text-lg font-bold hover:text-primary-300 transition-colors"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    {companyInfo.phone}
                  </a>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <h3 className="text-foreground-500 text-sm font-medium mb-2">営業時間</h3>
                    <p className="text-foreground-50 text-lg ">{companyInfo.hours}</p>
                  </div>
                  <div>
                    <h3 className="text-foreground-500 text-sm font-medium mb-2">定休日</h3>
                    <p className="text-foreground-50 text-lg ">{companyInfo.holiday}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 右側：Googleマップ */}
            <div
              ref={rightRef}
              className={`w-full min-h-[300px] md:min-h-[400px] rounded-xl overflow-hidden border border-background-300/30 transition-all duration-700 ${
                rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-6"
              }`}
            >
              
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3264.3434657101793!2d136.84577769999999!3d35.098133499999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6003798c1af6050b%3A0x930d583728258df2!2sChukyo%20Trading%20Co.%2C%20Ltd.!5e0!3m2!1sen!2sjp!4v1782265770137!5m2!1sen!2sjp"
                className="w-full h-full border-0"
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}